import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { apiClient } from "@/services/ApiService.js";
import VueSweetalert2 from "vue-sweetalert2";
import swal from "sweetalert2/dist/sweetalert2.all.min.js";
import moment from 'moment';

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);

const token = localStorage.getItem("token");
if (token) {
  apiClient.defaults.headers.common["Authorization"] = "Bearer " + token;
}
//else {
//apiClient.defaults.headers["Content-Type"] =
//  "application/x-www-form-urlencoded";
//}

apiClient.interceptors.response.use(
  response => {
    // intercept the global error
    return response;
  },
  function(error) {
    let originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      // if the error is 401 and hasent already been retried
      console.log("intercepta", error);
      store.commit("SET_LOADING", false);
      store.commit("AUTH_LOGOUT");
      router.push("/login");

      // originalRequest._retry = true // now it can be retried
    }
    if (error.response.status === 404 && !originalRequest._retry) {
      originalRequest._retry = true;
      // window.location.href = '/'
      return;
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('LL hh:mm A')
    }
});
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('ll')
    }
});
Vue.filter('formatDays', function(value) {
    if (value) {
        return moment(String(value)).fromNow();
    }
});
moment.locale('es-mx');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
